import { TRIPS } from '@/constants';
import constants from '@/helpers/constants';
import { ITrip } from '~/api/ITrip';

/**
 * '<#>' and '0' are BE placeholders for "no value" on shift fields. Treat them as absent
 * so a placeholder is never mistaken for a mismatching shift.
 */
const isUsableShiftId = (value?: string): boolean => Boolean(value) &&
  value !== constants.DATA_VALUES.DEFAULT_STRING &&
  value !== '0';

/**
 * ZD-20527: A pre-assigned trip belongs to the shift it was dropped on (trip.shiftId), not
 * to the vehicle. When an inactive shift shares its vehicle with a currently active unit,
 * the trip still carries that vehicle in unitId, so it lands in the active unit's bucket.
 * Such a trip belongs on its shift row only and must not surface on the active unit.
 *
 * Trips without a shiftId are kept — that is the legacy shape and the pre-assignment
 * cannot be attributed to any particular shift.
 *
 * @param trip - the trip being considered
 * @param unitShiftId - shift the unit is currently working, if any
 */
export const belongsToUnitShift = (trip: ITrip, unitShiftId?: string): boolean => {
  if (trip.tripStatus !== TRIPS.STATUS.PRE_ASSIGNED) return true;

  const tripShiftId = trip.shiftId ? String(trip.shiftId) : undefined;
  if (!isUsableShiftId(tripShiftId)) return true;

  const activeShiftId = unitShiftId ? String(unitShiftId) : undefined;
  return tripShiftId === activeShiftId;
};
